import { defineStore } from 'pinia';
import ServiceMessage from '../types/interfaces/global/ServiceMessage';
import serverFetch from '../globals/ServerFetch';

// eslint-disable-next-line import/prefer-default-export
export const usePromoMessagesStore = defineStore({
	id: 'promoMessages',
	state: () => ({
		/**
		 * Lista wiadomości.
		 */
		promoMessagesList: [] as ServiceMessage[],
		/**
		 * Liczba nieprzeczytanych wiadomości.
		 */
		promoMessagesCount: 0,
	}),
	actions: {
		/**
		 * Pobiera listę wiadomości z serwera.
		 */
		async update() {
			const result = [] as Array<ServiceMessage>;
			const messages = (await serverFetch('/profile/messages.ofer')).serviceMessages || [];
			let readCount = 0;

			for (const msg of (messages || [])) {
				if (msg.moreInfoLink === 'DisplayAppSurvey') {
					const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
					const isCordova = window.localStorage['IsApp'];
					if (navigator.userAgent.indexOf('appstore.oferteo') === -1 && (isSafari || !isCordova)) { continue; }
				}

				result.unshift({
					id: msg.id,
					type: msg.type || 'info',
					title: msg.title,
					message: msg.message,
					button: msg.buttonLabel || 'Zobacz więcej',
					dismissButton: msg.dismissButtonLabel || 'Przypomnij później',
					action: msg.moreInfoLink,
					date: new Date(msg.tsCreated),
					isRead: msg.read,
				});

				if (msg.read) { readCount++; }
			}

			this.promoMessagesCount = result.length - readCount;
			this.promoMessagesList = result;
		},

		/**
		 * Oznacza wszystkie wiadomości jako przeczytane.
		 */
		async readAll() {
			this.promoMessagesCount = 0;
			await serverFetch('/myoferteo/konto-json/read-all-messages.ofer');
		},

		/**
		 * Oznacza wiadomość jako przeczytaną.
		 */
		markAsRead(message:ServiceMessage) {
			const { id } = message;
			const foundMessage = this.promoMessagesList.find((m) => m.id === id);
			if (foundMessage && !foundMessage.isRead) {
				foundMessage.isRead = true;
				this.promoMessagesCount--;
			}
		},
	},
});
